module.exports = __webpack_public_path__ + "img/circle_complete.af469c3f.svg";